export default [
    {
        img: require('@/assets/img/item_01.png'),
        text: '大慈寺',
        tag: 0,
        dis: 5 
    },
    {
        img: require('@/assets/img/item_02.png'),
        text: '成都自然博物馆',  
        tag: 0,
        dis: 5    
    },
    {
        img: require('@/assets/img/item_03.png'),
        text: '金沙遗址博物馆', 
        tag: 0    
    },
    {
        img: require('@/assets/img/item_04.png'),
        text: '成都IFS', 
        tag: 1  
    },
    {
        img: require('@/assets/img/item_05.png'),
        text: '太古里', 
        tag: 1   
    },
    {
        img: require('@/assets/img/item_06.png'),
        text: '金融城双子塔', 
        tag: 1    
    },
    {
        img: require('@/assets/img/item_07.png'),
        text: '魁星楼街',  
        tag: 2,
        dis: 4   
    },
    {
        img: require('@/assets/img/item_08.png'),
        text: '望平街', 
        tag: 2,
        dis: 3
    },
    {
        img: require('@/assets/img/item_09.png'),
        text: '柳浪湾夜市',    
        tag: 2 
    },
    {
        img: require('@/assets/img/item_10.png'),
        text: '东安湖公园',    
        tag: 3,
        dis: 5
    },
    {
        img: require('@/assets/img/item_11.png'),
        text: '龙泉山森林公园', 
        tag: 3   
    },
    {
        img: require('@/assets/img/item_12.png'),
        text: '青城山',  
        tag: 3,
        dis: 5  
    },
    {
        img: require('@/assets/img/item_13.png'),
        text: '339电视塔',   
        tag: 4,
        dis: 2
    },
    {
        img: require('@/assets/img/item_14.png'),
        text: '玉林路小酒馆',    
        tag: 4,
        dis: 2
    },
    {
        img: require('@/assets/img/item_15.png'),
        text: '熊猫基地',   
        tag: 4  
    },
    {
        img: require('@/assets/img/item_16.png'),
        text: '天府广场',  
        tag: 0  
    },
    {
        img: require('@/assets/img/item_17.png'),
        text: '武侯祠',
        tag: 0    
    },
    {
        img: require('@/assets/img/item_18.png'),
        text: '杜甫草堂', 
        tag: 0,
        dis: 4  
    },
    {
        img: require('@/assets/img/item_19.png'),
        text: '东郊记忆', 
        tag: 1    
    },
    {
        img: require('@/assets/img/item_20.png'),
        text: 'COSMO',    
        tag: 1,
        dis: 3
    },
    {
        img: require('@/assets/img/item_21.png'),
        text: 'SKP',   
        tag: 1,
        dis: 2 
    },
    {
        img: require('@/assets/img/item_22.png'),
        text: '建设路第五大道',  
        tag: 2,
        dis: 3  
    },
    {
        img: require('@/assets/img/item_23.png'),
        text: '宽窄巷子', 
        tag: 2,
        dis: 2    
    },
    {
        img: require('@/assets/img/item_24.png'),
        text: '春熙路',   
        tag: 1  
    },
    {
        img: require('@/assets/img/item_25.png'),
        text: '西岭雪山', 
        tag: 3,
        dis: 4   
    },
    {
        img: require('@/assets/img/item_26.png'),
        text: '兴隆湖湿地公园',
        tag: 3,
        dis: 4   
    },
    {
        img: require('@/assets/img/item_27.png'),
        text: '都江堰',
        tag: 3,
        dis: 4   
    },
    {
        img: require('@/assets/img/item_28.png'),
        text: '成都欢乐谷',
        tag: 4     
    },
    {
        img: require('@/assets/img/item_29.png'),
        text: '夜游锦江', 
        tag: 4,
        dis: 4    
    },
    {
        img: require('@/assets/img/item_30.png'),
        text: '九眼桥',
        tag: 4    
    },
    {
        img: require('@/assets/img/item_31.png'),
        text: '人民公园', 
        tag: 0,
        dis: 2   
    },
    {
        img: require('@/assets/img/item_32.png'),
        text: '锦里',  
        tag: 2,
        dis: 4   
    },
    {
        img: require('@/assets/img/item_33.png'),
        text: '银泰in99',
        tag: 4,
        dis: 2     
    },
    {
        img: require('@/assets/img/item_34.png'),
        text: '大飞水景区',
        tag: 3,
        dis: 3   
    },
]